//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '../../../src/lib/util';
import SelectMemberModal from '../coupons/components/select-member-modal';

export default {
    name: 'shopInfo1',
    components: { SelectMemberModal },
    data() {
        const vm = this;
        return {
            loading: false,
            visible: false,
            saving: false,
            shopId: 0,
            shop: {},
            shopTypes: [
                {
                    id: 0,
                    value: '积分商城'
                },
                {
                    id: 1,
                    value: '线下实体店'
                }
            ],
            salesclerkColumns: [
                {
                    type: 'index', align: 'center', width: 60
                },
                {
                    key: 'loginUserName', align: 'center', title: '账户名'
                },
                {
                    key: 'name', align: 'center', title: '昵称'
                },
                {
                    key: 'mobile', align: 'center', title: '电话'
                },
                {
                    key: 'actions', align: 'center',
                    title: '操作',
                    width: 170,
                    render(h, params) {
                        const row = params.row;
                        const actions = [];
                        actions.push(h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            on: {
                                click: function() {
                                    vm.editSalesClerk(row);
                                }
                            }
                        }, '编辑'));
                        actions.push(h('Button', {
                            props: {
                                type: 'error',
                                size: 'small'
                            },
                            style: {
                                marginLeft: '5px'
                            },
                            on: {
                                click() {
                                    vm.delSalesClerk(row);
                                }
                            }
                        }, '删除'));
                        return h('div', actions);
                    }
                }
            ],
            salesclerks: [],
            salesclerkTotalCount: 0,
            salesclerkCurrentPage: 1,
            showSalesclerkEditModal: false,
            salesclerkEditTitle: '添加',
            salesclerk: {},
            salesclerkRules: {
                loginUserName: {
                    required: true,
                    message: '请输入账户名',
                    trigger: 'blur'
                }
            },
            showAddUserModal: false
        };
    },
    methods: {
        imgUrl(fileId) {
            return util.ajaxUrl + '/file/download/' + fileId + '?/5/w/100/h/100';
        },
        getShop() {
            this.loading = true;
            this.shop = {};
            abp.ajax.get('/api/services/app/Shop/GetShopById?id=' + this.shopId).then(resp => {
                console.log(resp.data.result);
                this.shop = resp.data.result;
            }).finally(() => {
                this.loading = false;
            });
        },
        handleView() {
            this.visible = true;
        },
        getPageSalesClerk() {
            this.loading = true;
            const skip = (this.pointCurrentPage - 1) * 10;
            abp.ajax.post('/api/services/app/SalesClerk/SearchSalesClerks', {
                shopId: this.shopId,
                maxResultCount: 10,
                skip: skip
            }).then(res => {
                this.salesclerks = [];
                this.salesclerks.push(...res.data.result.items);
                console.log(this.salesclerks);
            }).finally(() => {
                this.loading = false;
            });
        },
        salesclerkPageChange() {
            this.getPageSalesClerk();
        },
        editSalesClerk(salesclerk) {
            console.log(this.salesclerk);
            this.salesclerk = {};
            this.salesclerk = salesclerk;
            this.salesclerkEditTitle = salesclerk.id > 0 ? '编辑' : '添加';
            this.showSalesclerkEditModal = true;

        },
        saveSalesclerk() {
            console.log(this.$refs.salesclerkForm);
            this.$refs.salesclerkForm.validate(async (val) => {
                if (val) {
                    this.saving = true;
                    abp.ajax.post('/api/services/app/SalesClerk/SaveSalesClerk', this.salesclerk)
                        .then(res => {
                            this.showSalesclerkEditModal = false;
                            this.getPageSalesClerk();
                        }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        delSalesClerk(salesClerk) {
            this.loading = true;
            this.$Modal.confirm({
                title: '删除确认',
                content: '您确定要删除' + salesClerk.loginUserName + '吗？',
                onOk: () => {
                    abp.ajax.delete('/api/services/app/SalesClerk/DeleteSalesClerk?id=' + salesClerk.id)
                        .then(res => {
                            this.getPageSalesClerk();
                        }).finally(() => {
                        this.loading = false;
                    });
                },
                onCancel: () => {
                }
            });
        },
        showAddUser() {
            this.showAddUserModal = true;
        },
        addUser(data) {
            this.salesclerk.userId = data.id;
            this.salesclerk.name = data.name;
            this.salesclerk.loginUserName = data.name;
            this.salesclerk.mobile = data.phoneNumber;
            this.showAddUserModal = false;
        }
    },
    created() {
        this.shopId = parseInt(this.$route.params.id || 0);
        if (this.shopId != 0) {
            this.getShop();
            this.getPageSalesClerk();
        }
    },
    computed: {},
    mounted() {
    },
    watch: {}
};
